<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>计划管理</h4>
    </div>

    <!--新建计划-->
    <div>
      <span>
         <el-form  :rules="rules"
          :model="addFrom"
          ref="addFrom"
          class="demo-form-inline"
          label-width="110px" size="mini">
        <div class="addinpBox">
              <el-form-item label="合同信息：" prop="hetong" style="margin-left:7px;">
                <!--<el-button type="primary" size="mini" @click="heTongClick">选择合同</el-button>-->
              </el-form-item>
                <el-table
                  :data="tableList"
                  ref="table"
                  border
                  bordersize="mini"
                  style="width:95%;margin-top:10px;margin-left:3%;margin-bottom:17px"
                  center
                  :header-cell-style="{background:'#F5F5F5',color:'black'}"
                  :header-row-style="{height:'35px'}"
                  :row-style="{height:'25px'}"
                  highlight-current-row>
                  <el-table-column prop="collectPlanTime" label="计划时间" align="center" width="120">
                    <template >
                      <span>{{tableJiHuaStartTime}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="customerName"   label="客户名称" align="center"  ></el-table-column>
                  <el-table-column property="contractNo" label="合同号"  align="center" ></el-table-column>
                  <el-table-column prop="cumulativeAllowOut"    label="可发量" align="center" ></el-table-column>
                  <el-table-column prop="flowtoTypeShow"  label="流向" align="center" ></el-table-column>
                </el-table>
                <el-form-item label="流向:" >
                <el-col :span="5" >
                  <el-form-item  prop="liuXiang">
                    <el-input  placeholder="" maxlength="50" :validate-event = "false" disabled="disabled"  v-model.trim="addFrom.flowtoType" style="width:155px;"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="运输车队:" prop="cheDui" v-show="cheDuiShow">
                    <el-input  placeholder="" maxlength="50" :validate-event = "false" disabled="disabled"  v-model.trim="addFrom.cheDui" style="width:155px;"></el-input>
                  </el-form-item>
                </el-col>
                </el-form-item>
              <el-form-item label="计划量:" prop="jiHuaLiang" style="margin-top:10px;">
                <el-input  placeholder=""  :validate-event = "false"  v-model.trim="addFrom.jiHuaLiang" style="width:155px;"></el-input> &nbsp;吨
              </el-form-item>
              <el-form-item label="计划时间:" required style="margin-top:15px;">
                <el-col :span="4">
                  <el-input  placeholder="" maxlength="50" :validate-event = "false" disabled="disabled"  v-model.trim="addFrom.jiHuaStartTime" style="width:155px;"></el-input>
                </el-col>
                <el-col :span="1">至</el-col>
                <el-col :span="4">
                  <el-input  placeholder="" maxlength="50" :validate-event = "false" disabled="disabled"  v-model.trim="addFrom.jiHuaEndTime" style="width:155px;"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="收货地址:" prop="address" style="margin-top:10px;">
                <el-input  placeholder="" maxlength="5" :validate-event = "false"  v-model.trim="addFrom.address" style="width:300px;"></el-input>
             </el-form-item>
             <el-form-item label="备注:" prop="beiZhu" style="margin-top:17px;">
                <el-input  placeholder="" maxlength="5" :validate-event = "false"  v-model.trim="addFrom.beiZhu" style="width:400px;"></el-input>
             </el-form-item>
        </div>
        </el-form>
      </span>
      <div  class="btn">
        <el-button type="primary"   @click="changeClick('addFrom')"  :loading='addShengChengLoading'>修&nbsp;&nbsp;&nbsp;改</el-button>&nbsp;&nbsp;&nbsp;
        <!--<el-button type="primary"  @click="faBuClick('addFrom')"  :loading='addFaBuLoading'>发&nbsp;&nbsp;&nbsp;布</el-button>&nbsp;&nbsp;&nbsp;-->
        <el-button @click="quXiaoClick('addFrom')" >返&nbsp;&nbsp;&nbsp;回</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  TenantDictionary, // 字典
  tCollectPlanChange // 修改
} from '@/api/zhb'
export default {
  data () {
    return {
      title: '',
      h: '500px',
      total: 0,
      liuXiangOptions: [],
      value: '',
      tableList: [],
      heTongTableData: [],
      // 新增
      addShengChengLoading: false,
      addFaBuLoading: false,
      rules: {
        // liuXiang: [
        //     { required: true, message: '流向不能为空', trigger: 'change' }
        // ],
        jiHuaLiang: [
          { required: true, message: '请输入计划量', trigger: ['blur', 'change'] }
        ],
        // cheDui: [
        //     { required: true, message: '请选择车队', trigger: 'blur' }
        // ],
        jiHuaStartTime: [
          { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
        ],
        jiHuaEndTime: [
          { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
        ]
      },
      cheDuiList: [],
      addFrom: {
        jiHuaStartTime: '',
        jiHuaEndTime: '',
        cheDui: '',
        cheDuiCode: '',
        jiHuaLiang: '',
        flowtoType: '',
        address: '',
        beiZhu: '',
        liuXiangCode: ''
        // jiHuaTime: []
      },
      cheDuiShow: true, // 流向为集港车队隐藏
      changeId: '',
      heTongNum: '',
      heTongId: '',
      tableJiHuaStartTime: ''
    }
  },
  created () {
    this.getDictionary()
    this.getToDay()
  },
  mounted () {
    this.$nextTick(() => {
      // let rowData = this.$route.params.changeData
      let rowData = JSON.parse(localStorage.getItem('changeData'))
      // console.log(rowData, '111')
      // console.log(this.tableList, '333')
      this.tableList.push(rowData)
      // collectPlanTime
      this.heTongNum = rowData.contractNo
      this.heTongId = rowData.contractId
      this.addFrom.liuXiangCode = rowData.flowtoType
      this.addFrom.flowtoType = rowData.flowtoTypeShow
      this.addFrom.cheDui = rowData.fleetName
      this.addFrom.cheDuiCode = rowData.fleetCode
      this.addFrom.jiHuaLiang = rowData.planWeight
      this.addFrom.address = rowData.receAddress
      this.addFrom.beiZhu = rowData.remark
      this.changeId = rowData.id
      if (this.addFrom.flowtoType == '集港') {
        this.cheDuiShow = false
        this.addFrom.cheDui = ''
        this.addFrom.cheDuiCode = ''
      } else {
        this.cheDuiShow = true
        this.addFrom.cheDui = rowData.fleetName
        this.addFrom.cheDuiCode = rowData.fleetCode
      }
    })
  },
  methods: {
    /**
 * 日期格式化
 */
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 计划开始时间-当前日期早8点
    getToDay () {
      const dateStartStr = this.dateFormat(new Date(new Date(new Date().toLocaleDateString()).getTime() + 28800000)) // 当天的早8点时间戳
      const dateEndStr = this.dateFormat(new Date(new Date(new Date().toLocaleDateString()).getTime() + 43200000 * 3 - 14400000)) // 当天的早8点时间戳
      // console.log(dateEndStr)
      // console.log((new Date()).getTime(),'22222')  //当前时间戳
      const nowDate = (new Date()).getTime()
      // console.log(new Date(dateStartStr).getTime(),'333')   // 早八点时间戳
      const morningTime = new Date(dateStartStr).getTime()
      if (nowDate > morningTime) {
        this.tableJiHuaStartTime = this.timeStamp(new Date())
      } else {
        // 昨天的时间
        var day1 = new Date()
        day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000)
        var s1 = day1.getFullYear() + '-' + (day1.getMonth() + 1) + '-' + day1.getDate()
        // console.log(s1,'00000000')
        this.tableJiHuaStartTime = s1
      }
      this.addFrom.jiHuaStartTime = dateStartStr
      this.addFrom.jiHuaEndTime = dateEndStr
    },
    // 获取流向字典数据
    getDictionary () {
      TenantDictionary({
        groupNo: 'flowto_type'
      }).then(res => {
        this.liuXiangOptions = res.data
        // eslint-disable-next-line handle-callback-err
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      // this.getSearchData()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      // this.getSearchData()
    },
    // 修改
    changeClick (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addShengChengLoading = true
          tCollectPlanChange({
            id: this.changeId,
            contractId: this.heTongId, // 合同id
            contractNo: this.heTongNum, // 合同编号
            flowtoType: this.addFrom.liuXiangCode, // 流向
            fleetCode: this.addFrom.cheDuiCode, // 车队code
            fleetName: this.addFrom.cheDui, // 车队名称
            planWeight: this.addFrom.jiHuaLiang, // 计划量,例：999999.999
            startTimeStr: this.addFrom.jiHuaStartTime, // 开始时间"yyyy-MM-dd HH:mm:ss"
            endTimeStr: this.addFrom.jiHuaEndTime, // 结束时间"yyyy-MM-dd HH:mm:ss"
            receAddress: this.addFrom.address, // 收货地址
            remark: this.addFrom.beiZhu // 备注
          }).then(res => {
            this.addShengChengLoading = false
            this.$message.success('修改成功！')
            this.$router.push('/planManagement')
          }).catch(err => {
            this.addShengChengLoading = false
            this.$message.error(err.message)
          })
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    },
    // 新增返回
    quXiaoClick (addFrom) {
      this.addMark = false
      this.$refs[addFrom].resetFields()
      this.$router.push('/planManagement')
    },
    // 年月日格式化
    timeStamp: function (value) {
      if (!value) return ''
      var now = new Date(value)
      console.log('time:' + JSON.stringify(now))
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    }
  }
}
</script>
<style scoped lang='less'>
.inpBox{
  margin: 10px 0 0 -30px;
}

 /deep/ .inpBox .el-range-editor--mini .el-input__inner {
   width: 150px;
}
.searchBtnBox{
  margin-top: 10px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
.btn{
    width: 320px;
    // border: solid 1px;
    margin: 50px auto;
}
</style>
